import { render } from "./DialogConfirmCancelReservation.vue?vue&type=template&id=203111a7"
import script from "./DialogConfirmCancelReservation.vue?vue&type=script&lang=js"
export * from "./DialogConfirmCancelReservation.vue?vue&type=script&lang=js"
script.render = render

export default script